const dropCapTextBlock = {
  key: 'dropCapTextBlock',
  componentKey: 'textblock',
  label: 'Drop cap'
};

export default dropCapTextBlock;
